<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('housing_reports')" :is-filter="false">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('housing_reports')" :is-filter="false">
                </HeaderMobile>
            </template>
            <div class="row data-form">
                <div class="col-12">
                    <ValidationObserver ref="form">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <ValidationProvider name="report" rules="required" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('report')">
                                        <multi-selectbox :allow-empty="false" :multiple="false"
                                                         :validate-error="errors[0]" :options="reportOptions"
                                                         v-model="form.report"></multi-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </div>
                            <div class="col-12 col-sm-6">
                                <ValidationProvider name="response_type" rules="required" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('report_type')">
                                        <multi-selectbox :allow-empty="false" :multiple="false"
                                                         :validate-error="errors[0]" :options="responseTypeOptions"
                                                         v-model="form.response_type"></multi-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </div>
                            <div class="col-12">
                                <div class="row align-items-center">
                                    <div class="col-12 col-md-4 mb-3" v-if="['1'].includes(form.report)">
                                        <ValidationProvider name="number" :rules="['1'].includes(form.report) ? 'required' : ''" v-slot="{ valid, errors }">
                                             <SelectDate v-model="form.date" date-format="'MM/DD/YYYY'" :validation-error="errors[0]"/>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-12 col-md-4 mb-3" v-if="['2','3','4', '6'].includes(form.report)" >
                                        <ValidationProvider name="number" :rules="['2','4', '6'].includes(form.report) ? 'required' : ''" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('start_date') + ' '+ $t('end_date')" class="mb-0">
                                                <v-date-picker v-model="dateInterval" is-range locale="en">
                                                    <template v-slot="{ inputValue, inputEvents }">
                                                        <div class="d-flex align-items-center">
                                                            <div class="flex-grow-1 mr-1">
                                                                <b-form-group class="m-0">
                                                                    <input
                                                                        :value="inputValue.start"
                                                                        v-on="inputEvents.start"
                                                                        :placeholder="$t('start_date')"
                                                                        class="form-control"
                                                                    />
                                                                </b-form-group>
                                                            </div>
                                                            <div class="flex-grow-1 ml-1">
                                                                <b-form-group class="m-0">
                                                                    <input
                                                                        :value="inputValue.end"
                                                                        v-on="inputEvents.end"
                                                                        :placeholder="$t('end_date')"
                                                                        class="form-control"
                                                                    />
                                                                </b-form-group>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </v-date-picker>
                                            </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-12 col-md-4 mb-3" v-if="['2','3'].includes(form.report)">
                                        <ValidationProvider name="housing_building_id" rules="" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('housing_building')">
                                                <HouseBuildingSelectbox
                                                    v-model="form.housing_building_id"
                                                    :validate-error="errors[0]"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-12 col-md-4 mb-3" v-if="['2','3'].includes(form.report)" >
                                        <ValidationProvider name="housing_room_id" rules="" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('housing_rooms')">
                                                <HouseRoomSelectbox
                                                    :housing_building_id="form.housing_building_id"
                                                    v-model="form.housing_room_id"
                                                    :validate-error="errors[0]"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-12 col-md-4 mb-3" v-if="['3'].includes(form.report)" >
                                        <ValidationProvider name="category" rules="" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('categories')">
                                                <parameterSelectbox
                                                    :code="'housing_work_order_request_categories'"
                                                    v-model="form.category"
                                                    :validate-error="errors[0]"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-12 col-md-4 mb-3" v-if="['2'].includes(form.report)" >
                                        <ValidationProvider name="gender" rules="" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('gender')">
                                                <gender-selectbox
                                                    :validate-error="errors[0]"
                                                    v-model="form.gender"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-12 col-md-4 mb-3" v-if="['2'].includes(form.report)" >
                                        <ValidationProvider name="type" rules="" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('type')">
                                                <parameterSelectbox
                                                    :code="'housing_room_types'"
                                                    v-model="form.room_type"
                                                    :validate-error="errors[0]"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-12 col-md-4 mb-3" v-if="['2','3'].includes(form.report)" >
                                        <ValidationProvider name="floor" rules="" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('floor')">
                                                <b-form-input v-model="form.floor">
                                                </b-form-input>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-12 col-md-4 mb-3" v-if="['3'].includes(form.report)" >
                                        <ValidationProvider name="status" rules="" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('status')">
                                                <parameterSelectbox
                                                    :code="'housing_work_order_request_statuses'"
                                                    v-model="form.status"
                                                    :validate-error="errors[0]"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                    <processing-button @click="send" label="get_report"
                                                       :processing="processing"></processing-button>
                                </div>
                            </div>

                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </app-layout>
    </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout"
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'
import {ValidationObserver, ValidationProvider} from "vee-validate";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox";
import ProcessingButton from "@/components/elements/ProcessingButton";

import { reports as reportData } from '@/modules/housingReports/data/data.js';
import HousingReportService from "@/services/HousingReportService";
import moment from "moment";
import qs from "qs";
import HouseBuildingSelectbox from "@/components/interactive-fields/HouseBuildingSelectbox.vue";
import HouseRoomSelectbox from "@/components/interactive-fields/HouseRoomSelectbox.vue";
import GenderSelectbox from "@/components/interactive-fields/GenderSelectbox.vue";
import ModuleDateSelectbox from "@/components/interactive-fields/ModuleDateSelectbox.vue";



export default {
    components: {
        ModuleDateSelectbox,
        GenderSelectbox,
        HouseRoomSelectbox,
        HouseBuildingSelectbox,
        ProcessingButton,
        MultiSelectbox,
        AppLayout,
        ValidationProvider,
        ValidationObserver,
        Header,
        HeaderMobile
    },
    metaInfo() {
        return {
            title: this.$t('housing_reports'),
        }
    },
    data() {
        return {
            form: {
                response_type: 'excel'
            },
            responseTypeOptions: [
                {value: 'page', text: this.$t('page')},
                {value: 'excel', text: this.$t('excel')},
                {value: 'pdf', text: 'PDF'},
            ],
            dateInterval:null,
            processing: false,
            reportName: "",
            start_date_end_date:false,
            completed: false,
            student_list:false
        }
    },
    computed: {
        reportOptions() {
            return reportData.filter((item) => {
                return this.checkPermission(item.permission)
            })
        }
    },
    methods: {
        filterClear(){
            this.form={
                response_type: 'excel',
                report:this.form.report
            }
        },
        async send() {
            const isValid = await this.$refs.form.validate();
            if (isValid) {
                this.processing = true;
                this.reportName = this.getOptionText(this.reportOptions, this.form.report);
                let config = {params: this.form};
                let isArrayBuffer = false;
                if (this.form.response_type !== 'page') {
                    config.responseType = 'arraybuffer';
                    isArrayBuffer = true;
                }
                if (this.form.report === '1') {
                    const data = {
                        params:{
                            filter:{
                                due_date_before:this.form.date
                            }
                        },
                        paramsSerializer: (params) => qs.stringify(params, {encode: false})
                    }
                    data.params.response_type = this.form.response_type;
                    data.responseType = config.responseType;
                    HousingReportService.agingSummaryReport(data).then(this.callback).catch(e => {
                        this.showErrors(e, this.$refs.form, isArrayBuffer);
                    }).finally(() => {
                        this.processing = false;
                    });
                }else if (this.form.report === '2') {
                    const data = {
                        params:{
                            start_date: moment(this.dateInterval.start).format("MM/DD/YYYY"),
                            end_date: moment(this.dateInterval.end).format("MM/DD/YYYY"),
                            building_id: this.form.housing_building_id,
                            room_id: this.form.housing_room_id,
                            gender: this.form.gender,
                            room_type: this.form.type,
                        },
                        paramsSerializer: (params) => qs.stringify(params, {encode: false})
                    }
                    data.params.response_type = this.form.response_type;
                    data.responseType = config.responseType;
                    HousingReportService.AvailabilityTenantInformationReport(data).then(this.callback).catch(e => {
                        this.showErrors(e, this.$refs.form, isArrayBuffer);
                    }).finally(() => {
                        this.processing = false;
                    });
                }else if (this.form.report === '3') {
                    const data = {
                        params:{
                            created_between: (this.dateInterval.date) ? moment(this.dateInterval.start).format("MM/DD/YYYY")+','+moment(this.dateInterval.end).format("MM/DD/YYYY"):null,
                            building_id: this.form.housing_building_id,
                            room_id: this.form.housing_room_id,
                            floor: this.form.floor,
                            work_order_has_category: this.form.category,
                        },
                        paramsSerializer: (params) => qs.stringify(params, {encode: false})
                    }
                    data.params.response_type = this.form.response_type;
                    data.responseType = config.responseType;
                    HousingReportService.workOrderMaintenanceRequestReport(data).then(this.callback).catch(e => {
                        this.showErrors(e, this.$refs.form, isArrayBuffer);
                    }).finally(() => {
                        this.processing = false;
                    });
                }else if (this.form.report === '4') {
                    const data = {
                        params:{
                            start_date: moment(this.dateInterval.start).format("MM/DD/YYYY"),
                            end_date: moment(this.dateInterval.end).format("MM/DD/YYYY"),
                        },
                        paramsSerializer: (params) => qs.stringify(params, {encode: false})
                    }
                    data.params.response_type = this.form.response_type;
                    data.responseType = config.responseType;
                    HousingReportService.HousingBankReconciliation(data).then(this.callback).catch(e => {
                        this.showErrors(e, this.$refs.form, isArrayBuffer);
                    }).finally(() => {
                        this.processing = false;
                    });
                } else if (this.form.report === '5') {
                    const data = {
                        params:{},
                        paramsSerializer: (params) => qs.stringify(params, {encode: false})
                    }
                    data.params.response_type = this.form.response_type;
                    data.responseType = config.responseType;
                    HousingReportService.housingCashFlowReport(data).then(this.callback).catch(e => {
                        this.showErrors(e, this.$refs.form, isArrayBuffer);
                    }).finally(() => {
                        this.processing = false;
                    });
                } else if (this.form.report === '6') {
                    const data = {
                        params:{
                            start_date: moment(this.dateInterval.start).format("MM/DD/YYYY"),
                            end_date: moment(this.dateInterval.end).format("MM/DD/YYYY"),
                        },
                        paramsSerializer: (params) => qs.stringify(params, {encode: false})
                    }
                    data.params.response_type = this.form.response_type;
                    data.responseType = config.responseType;

                    HousingReportService.housingCollectionReport(data).then(this.callback).catch(e => {
                        this.showErrors(e, this.$refs.form, isArrayBuffer);
                    }).finally(() => {
                        this.processing = false;
                    });
                }
                if (config.params.date){
                    delete config.params.date;
                }
            }
            },
            callback(response) {
                if (this.form.response_type == 'page') {
                    this._openFile(response);
                } else if (this.form.response_type == 'excel') {
                    this._downloadFile(response, this.reportName + '.xlsx');
                } else if (this.form.response_type == 'pdf') {
                    this._downloadFile(response, this.reportName + '.pdf');
                }
            }
        },
        watch: {
            'form.report'(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.form = {response_type: 'excel', report: newVal}
                }
            },
            'form.response_type'(newVal,oldVal) {
                if (newVal !== oldVal) {
                    this.form = {...this.form,response_type: newVal}
                }

            }
        },

};
</script>

